import { cssToObject } from '../../../../../utils/cssToObject';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';

const {theme} = defaultTheme;

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  withoutRating: {
    opacity: 0.7,
  },

  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginLeft: 12,
  },

  textContent: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 4,
  },

  category: {
    ...cssToObject(theme.mixin.fontCaptionM_Caps),
    color: theme.colorVariables.textDark,
    margin: [0, 4, 0, 0],
    whiteSpace: 'nowrap',
  },

  categoryEmpty: {
    color: theme.colorVariables.textNoteDark,
  },

  reviewCount: {
    ...cssToObject(theme.mixin.fontTextXS),
    margin: 0,
    color: theme.colorVariables.textNoteDark,
    textAlign: 'right',
  },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
